import { deleteAlarmMutation } from '@akin-home/alarms/frontend';
import { deleteAlertMutation } from '@akin-home/alerts/frontend';
import { CalendarItemType } from '@akin-home/amplify';
import { deleteEventMutation } from '@akin-home/events/frontend';
import { deleteMealMutation } from '@akin-home/meals/frontend';

/** This funciton can delete any calendar item */
export const deleteCalendarItemMutation = async (
  id: string,
  type: CalendarItemType
) => {
  switch (type) {
    case CalendarItemType.Event:
      return deleteEventMutation({ input: { id } });
    case CalendarItemType.Alert:
      return deleteAlertMutation({ input: { id } });
    case CalendarItemType.Alarm:
      return deleteAlarmMutation({ input: { id } });
    case CalendarItemType.Meal:
      return deleteMealMutation({ input: { id } });
    default:
      return undefined;
  }
};
